import React, { useState, useEffect } from 'react';
import { calendarGET, deleteAppointment } from './CalendarApi';
import dayjs from 'dayjs';
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Table,
} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { participantsDELETE, participantsPATCH, eventPATCH ,eventDELETE} from './Api';

const Schedules = ({ selectedDate }) => {


  const [appointments, setAppointments] = useState([]);
  const [selectedAppt, setSelectedAppt] = useState(null);
  const [localData, setLocalData] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [isParticipant, setIsParticipant] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const fetchAppointments = async () => {
    try {
      const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');
      const data = await calendarGET(formattedDate);
      setAppointments(data);
    } catch (err) {
      console.error('❌ Failed to fetch appointments:', err);
    }
  };

  useEffect(() => {
    if (selectedDate) fetchAppointments();
  }, [selectedDate]);

  const handleView = (appt) => {
    if (appt.type === 'event') {
      const event = appt.event || {};
      const isOrganizer = event.is_organizer;
      const participantStatus = event.participant_status;
      const isParticipant = event.is_participant;

      let filteredParticipants = [];
      if (isOrganizer) {
        filteredParticipants = event.participants || [];
      } else if (participantStatus === 'approved') {
        filteredParticipants = (event.participants || []).filter(
          (p) => p.status === 'approved'
        );
      } else {
        filteredParticipants = (event.participants || []).filter(
          (p) => p.status === participantStatus
        );
      }

      setLocalData({
        type: 'event',
        event_name: event.event_name || '',
        event_date: event.event_date || '',
        start_time: event.time_range?.split('-')[0] || '',
        end_time: event.time_range?.split('-')[1] || '',
        description: event.description || '',
        venue: event.venue || '',
        address: event.address || '',
        permission: event.permission || 'none',
        max_participants: event.max_participants || 0,
        participants: filteredParticipants,
        isOrganizer,
        id: event.id,
      });

      setIsParticipant(isParticipant);
    } else if (appt.type === 'conversation') {
      setLocalData({
        type: 'conversation',
        target_id: appt.target_id,
        schedule_name: appt.schedule_name,
        date: appt.date,
        hour: appt.hour,
        conversation: appt.conversation || [],
      });
    }

    setSelectedAppt(appt);
    setShowViewModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDeleteClick = (appt) => {
    setSelectedAppt(appt);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
    
      
       if (localData?.type === 'conversation' || localData?.type === 'match' ) {
       
      


        await deleteAppointment(localData.id);

      } else if (localData?.isOrganizer) {
        await eventDELETE(localData.id);
      //  await eventPATCH({ id: localData.id, delete: true });
      } else if (isParticipant) {
       await participantsDELETE(localData.id);
      }

      await fetchAppointments();
      setShowDeleteModal(false);
      setShowViewModal(false);

    
    } catch (err) {
      console.error('❌ Failed to delete:', err);
      alert('Failed to delete: ' + err.message);
    }
  };

  const truncateText = (text, maxLength = 20) => {
    if (!text) return '(Untitled)';
    return text.length > maxLength ? text.slice(0, maxLength) + '…' : text;
  };

  const isReadOnly = !localData?.isOrganizer;


 const nowPH = new Date();

const todayDate = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Manila',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
}).format(nowPH).replace(/\//g, '-');

const currentTime = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Manila',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
}).format(nowPH);

const handleTimeChange = (field) => (e) => {
  const value = e.target.value;

  setLocalData((prev) => {
    const updated = { ...prev, [field]: value };

    const isToday = updated.event_date === todayDate;

    // validate start time
    if (field === 'start_time') {
      if (isToday && value < currentTime) {
        alert('Start time cannot be earlier than current time');
        return prev;
      }

      if (updated.end_time && value >= updated.end_time) {
        alert('Start time must be earlier than end time');
        return prev;
      }
    }

    // validate end time
    if (field === 'end_time') {
      if (updated.start_time && value <= updated.start_time) {
        alert('End time must be later than start time');
        return prev;
      }
    }

    return updated;
  });
};

  return (
    <Container className="p-0">
      <Row className="align-items-center mb-2">
        <Col>
          <h6 className="text-uppercase text-muted">My Schedules</h6>
        </Col>
      </Row>


      <div className="w-100" style={{ height: '100%' }}>
        {appointments.length > 0 ? (
          appointments.map((appt) => {
            const name =
              appt.type === 'event'
                ? appt.event?.event_name
                : appt.schedule_name;

            return (
              <Row
                key={appt.appointment_id}
                className="mb-2 p-2 border rounded align-items-center"
              >
                <Col className="text-start"> {/* 👈 changed from text-center */}
                  <div
                    style={{
                      overflowX: 'hidden',
                      whiteSpace: 'nowrap',
                      maxWidth: '100%',
                      textOverflow: 'ellipsis',
                    }}
                    title={name || '(Untitled)'}
                  >
                    <strong>{truncateText(name)}</strong>
                  </div>
                  <div className="small text-muted">{appt.hour}</div>
                </Col>

                <Col xs="auto">
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={() => handleView(appt)}
                  >
                    View
                  </Button>
                </Col>
              </Row>

            );
          })
        ) : (
          <p className="text-muted">No appointments</p>
        )}
      </div>

      {/* View Modal */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Event Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>


          {/* Event */}
          {localData && localData.type === "event" && (
            <>
              {/* Event Header */}
              <Row className="mb-3 g-3 align-items-end">
                {/* Event Name */}
                <Col xs={12} md={8} className="d-flex flex-column">
                  <label className="form-label-sm mb-1">Event Name</label>
                  <input
                    type="text"
                    name="event_name"
                    value={localData.event_name}
                    onChange={handleChange}
                    className="form-control"
                    style={{
                      width: '100%',
                      height: '60px',
                      fontSize: '1.1rem',
                      padding: '0.5rem',
                    }}
                    readOnly={isReadOnly}
                  />
                </Col>

                {/* Event Date */}
                <Col xs={12} md={4} className="d-flex flex-column">
                  <label className="form-label-sm mb-1">Event Date</label>
                  <DatePicker
                    selected={localData.event_date ? new Date(localData.event_date) : null}
                    onChange={(date) =>
                      setLocalData((prev) => ({
                        ...prev,
                        event_date: date ? date.toISOString().split("T")[0] : '',
                      }))
                    }
                    dateFormat="yyyy-MM-dd"
                    minDate={new Date()}
                    required
                    customInput={
                      <input
                        type="text"
                        className="form-control"
                        style={{
                          width: '100%',
                          height: '60px',
                          fontSize: '1.1rem',
                          padding: '0.5rem',
                        }}
                      />
                    }
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                  />
                </Col>
              </Row>

              {/* Times */}
              <Row className="mb-2">
                <Col xs="auto">
                  <label className="form-label form-label-sm me-1 mb-0">Start Time</label>
                  <input
                    className="form-control form-control-sm"
                    type="time"
                    name="start_time"
                    value={localData.start_time || ''}
    onChange={handleTimeChange('start_time')}
                    style={{ width: '200px' }}
                    readOnly={isReadOnly}
                    onClick={(e) => {
                      if (!isReadOnly) e.currentTarget.showPicker?.();
                    }}
                    disabled
                  />
                </Col>

                <Col xs="auto">
                  <label className="form-label form-label-sm me-1 mb-0">End Time</label>
                  <input
                    className="form-control form-control-sm"
                    type="time"
                    name="end_time"
                    value={localData.end_time || ''}
    onChange={handleTimeChange('end_time')}
                    style={{ width: '200px' }}
                    readOnly={isReadOnly}
                    onClick={(e) => {
                      if (!isReadOnly) e.currentTarget.showPicker?.();
                    }}
                    disabled
                  />
                </Col>
              </Row>

              {/* Description */}
              <div className="mb-3">
                <textarea
                  className="form-control form-control-sm"
                  name="description"
                  value={localData.description || ''}
                  onChange={handleChange}
                  style={{ height: '150px' }}
                  readOnly={isReadOnly}
                />
              </div>

              {/* Venue + Address + Participants */}
              <Row className="mb-3">
                <Col xs="auto">
                  <label className="form-label form-label-sm mb-0 me-2">Max Participants</label>
                  <input
                    className="form-control form-control-sm"
                    type="number"
                    name="max_participants"
                    value={localData.max_participants || ''}
                    onChange={handleChange}
                    style={{ width: '150px' }}
                    readOnly={isReadOnly}
                  />
                </Col>
                <Col xs="auto">
                  <label className="form-label form-label-sm mb-0 me-2">Address</label>
                  <input
                    className="form-control form-control-sm"
                    name="address"
                    value={localData.address || ''}
                    onChange={handleChange}
                    style={{ width: '300px' }}
                    readOnly={isReadOnly}
                  />
                </Col>
                <Col xs="auto">
                  <label className="form-label form-label-sm mb-0 me-2">Venue</label>
                  <input
                    className="form-control form-control-sm"
                    name="venue"
                    value={localData.venue || ''}
                    onChange={handleChange}
                    style={{ width: '200px' }}
                    readOnly={isReadOnly}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs="auto">
                  <label className="form-label-sm mb-0 me-2">Permission</label>
                  <select
                    className="form-select form-select-sm"
                    name="permission"
                    value={localData.permission || 'none'}
                    onChange={handleChange}
                    style={{ width: '200px' }}
                    disabled={isReadOnly}
                  >
                    <option value="none">None</option>
                    <option value="need_permission">Need Permission</option>
                  </select>
                </Col>
              </Row>

              {/* Participants Table */}
              <Table size="sm" bordered hover responsive>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {localData.participants?.length > 0 ? (
                    localData.participants.map((p, idx) => (
                      <tr key={idx}>
                        <td>{p.full_name}</td>
                        <td>{p.email ?? 'Hidden'}</td>
                        <td>
                          {localData.isOrganizer ? (
                            <select
                              className="form-select form-select-sm"
                              value={p.status}
                              onChange={async (e) => {
                                const newStatus = e.target.value;
                                const old = p.status;
                                try {
                                  const updated = [...localData.participants];
                                  updated[idx] = { ...updated[idx], status: newStatus };
                                  setLocalData((prev) => ({ ...prev, participants: updated }));
                                  await participantsPATCH(p.user_id, {
                                    event_id: localData.id,
                                    status: newStatus,
                                  });
                                } catch (err) {
                                  const reverted = [...localData.participants];
                                  reverted[idx] = { ...reverted[idx], status: old };
                                  setLocalData((prev) => ({ ...prev, participants: reverted }));
                                  const msg = err.response?.data?.detail;
                                  alert('❌ Failed to update changes: ' + (msg || err.message));
                                }
                              }}
                              disabled={isReadOnly}
                            >
                              <option value="pending">Pending</option>
                              <option value="approved">Approved</option>
                              <option value="rejected">Rejected</option>
                            </select>
                          ) : (
                            p.status
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center text-muted">
                        No participants
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </>
          )}



          {/* Conversation */}
          {localData && localData.type === 'conversation' && (
            <div className="p-3" style={{ background: '#fefefe' }}>
              <div className="text-center mb-4">
                <h3 style={{ fontWeight: '700', marginBottom: '5px' }}>
                  {localData.schedule_name}
                </h3>
                <small className="text-muted" style={{ fontSize: '1rem' }}>
                  {dayjs(localData.date).format('MMM D, YYYY')} • {localData.hour}
                </small>
              </div>

              <h5 className="mb-4 text-center" style={{ fontWeight: '600' }}>
                People in this conversation
              </h5>

              <div className="d-flex flex-wrap justify-content-center gap-4">
                {localData.conversation.map((user, idx) => (
                  <div
                    key={idx}
                    className="text-center"
                    style={{
                      minWidth: 120,
                      padding: '12px',
                      borderRadius: '14px',
                      background: '#f8f9fa',
                    }}
                  >
                    <img
                      src={
                        user.profile_image
                          ? `${user.profile_image}?t=${Date.now()}`
                          : ''
                      }
                      alt={user.full_name}
                      style={{
                        width: 80,
                        height: 80,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        marginBottom: '10px',
                      }}
                    />
                    <div style={{ fontSize: '1rem', fontWeight: '600' }}>
                      {user.full_name}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>


          {/* Leave event button for participants */}
          {localData?.type === 'event' &&
            !localData?.isOrganizer &&
            isParticipant && (
              <Button
                variant="danger"
                onClick={async () => {
                  try {
                  
                    await participantsDELETE(localData.id);
                    await fetchAppointments();
                    setShowViewModal(false);
                  } catch (err) {
                    console.error('❌ Failed to leave event:', err);
                    alert('Failed to leave event: ' + err.message);
                  }
                }}
              >
                Leave Event
              </Button>
            )}

          {/* Save + Delete buttons for organizers */}
          {localData?.type === 'event' && localData?.isOrganizer && (
            <>




              <Button
                variant="danger"
                onClick={() => handleDeleteClick(selectedAppt)}
              >
                Delete Event
              </Button>

              <Button
                variant="primary"
                onClick={async () => {
  try {
    const today = dayjs().format('YYYY-MM-DD');
    const nowTime = dayjs().format('HH:mm');

    if (!localData.event_date) {
      alert('Event date is required');
      return;
    }

    if (localData.event_date < today) {
      alert('Event date cannot be in the past');
      return;
    }

    if (
      localData.event_date === today &&
      localData.start_time < nowTime
    ) {
      alert('Start time cannot be in the past');
      return;
    }

    const maxParticipants = Number(localData.max_participants);
    if (isNaN(maxParticipants) || maxParticipants <= 0) {
      alert('❌ Max participants must be greater than 0.');
      return;
    }

    const payload = {
      id: localData.id,
      event_name: localData.event_name,
      event_date: localData.event_date,
      time_range: `${localData.start_time}-${localData.end_time}`,
      description: localData.description,
      venue: localData.venue,
      max_participants: maxParticipants,
      permission: localData.permission,
      address: localData.address,
    };

    await eventPATCH(payload);
    await fetchAppointments();
    setShowViewModal(false);
  } catch (err) {
    console.error('❌ Failed to save changes:', err);
    alert('Failed to save changes: ' + err.message);
  }
}}
              >
                Save Changes
              </Button>

            </>
          )}

          {/* Delete for conversation */}
          {localData?.type === 'conversation' && (
            <Button
              variant="danger"
              onClick={() => handleDeleteClick(selectedAppt)}
            >
              Delete Appointment
            </Button>
          )}
        </Modal.Footer>




      </Modal>

      {/* Delete Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this appointment? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Schedules;
